import { render, staticRenderFns } from "./product-purchase-form.vue?vue&type=template&id=3806f28c&scoped=true&"
import script from "./product-purchase-form.vue?vue&type=script&lang=js&"
export * from "./product-purchase-form.vue?vue&type=script&lang=js&"
import style0 from "./product-purchase-form.vue?vue&type=style&index=0&id=3806f28c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3806f28c",
  null
  
)

export default component.exports